import moment from "moment";
import React from 'react';
import classnames from 'classnames';
import { useStore } from "shared/hooks";
import { observer } from 'mobx-react';
import { UiIcon } from 'shared/uikit';
import { useMedia, useNavigate } from "shared/hooks";
import { ApplicationModule } from "shared/modules";
import { ICONS, ROUTES } from "shared/constants";
import { PProfileImage } from "../PProfileImage";
import { PProfileISpring } from "../PProfileISpring";
import { PProfileOutlook } from "../PProfileOutlook";
import { PProfileWidgets } from "../PProfileWidgets";
import { PProfileNotifications } from "../PProfileNotifications";
import { PProfileUser } from "../PProfileUser";
import { PProfileUserResponsibilities } from "../PProfileUserResponsibilities";
import { PProfileUserPersonalFields } from "../PProfileUserPersonalFields";
import { PProfileAvailability } from "../PProfileAvailability";
import { PProfileUnavailable } from "../PProfileUnavailable";

const TAB_INFO = {
    SETTINGS: "settings",
    PERSONAL_DATA: "personalData"
}

export const PProfileSettings = observer(() => {
    const store = useStore(() => ({
        activeTab: TAB_INFO.SETTINGS
    }));

    const navigate = useNavigate();

    const {
        isMobileOrTablet
    } = useMedia({
        is320: 1,
        is1024: 3
    });

    const handleClick = (tab: string) => {
        if (TAB_INFO.SETTINGS === tab) {
            store.set('activeTab', tab)
        }

        if (TAB_INFO.PERSONAL_DATA === tab) {
            store.set('activeTab', tab)
        }
    }

    return (
        <div className="p-user">
            <div className="p-user__top p-user__top--profile">
                <div className="p-user__name">
                    Профиль
                </div>

                <PProfileAvailability/>
            </div>

            {
                isMobileOrTablet && (
                    <PProfileUnavailable user={ApplicationModule.user} isProfile={true}/>
                )
            }

            <div className="p-user__wrapper">
                <div className="p-user__aside">
                    <PProfileImage/>

                    {!isMobileOrTablet && (
                        <>
                            <PProfileWidgets/>
                            <PProfileNotifications/>
                            <PProfileISpring/>
                            <PProfileOutlook/>

                            <div className="p-user-section p-user-section--16plpr">
                                <div className="p-user-section__exit"
                                    onClick={() => {
                                        ApplicationModule.setAccessToken(null);
                                        navigate(ROUTES.LOGIN());
                                    }}
                                >
                                    <UiIcon
                                        size={20}
                                        icon={ICONS["EXIT_ICON"]}
                                    />
                                    Выйти из профиля
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <div className="p-user__main">
                    {
                        !isMobileOrTablet && (
                            <PProfileUnavailable user={ApplicationModule.user} isProfile={true}/>
                        )
                    }
                    <PProfileUser/>

                    {!isMobileOrTablet && (
                        <>
                            <PProfileUserResponsibilities/>
                        </>
                    )}

                    {ApplicationModule.user.birthdayAt && (
                        <div className="p-user-section">
                            <div className="p-user-section__title">День рождения</div>
                            <div className="p-user-section__description">
                                {moment(ApplicationModule.user.birthdayAt).format('D MMMM')}
                            </div>
                        </div>
                    )}

                    {!isMobileOrTablet && (
                        <>
                            <PProfileUserPersonalFields/>
                        </>
                    )}

                    {isMobileOrTablet && (
                        <>
                            <div className="p-user__tabs">
                                <div className={classnames("p-user__tabs-btn", { "p-user__tabs-btn--active" : store.activeTab === TAB_INFO.SETTINGS })} onClick={() => handleClick(TAB_INFO.SETTINGS)}>Настройки</div>
                                <div className={classnames("p-user__tabs-btn", { "p-user__tabs-btn--active" : store.activeTab === TAB_INFO.PERSONAL_DATA })} onClick={() => handleClick(TAB_INFO.PERSONAL_DATA)}>Персональные данные</div>
                            </div>

                            {
                                store.activeTab === TAB_INFO.PERSONAL_DATA && (
                                    <>
                                        <PProfileUserResponsibilities/>
                                        <PProfileUserPersonalFields/>
                                    </>
                                )
                            }

                            {
                                store.activeTab === TAB_INFO.SETTINGS && (
                                    <>
                                        <PProfileWidgets/>
                                        <PProfileNotifications/>

                                        <PProfileISpring/>
                                        <PProfileOutlook/>
                                    </>
                                )
                            }

                            <div className="p-user-section p-user-section--16plpr">
                                <div className="p-user-section__exit"
                                    onClick={() => {
                                        ApplicationModule.setAccessToken(null);
                                        navigate(ROUTES.LOGIN());
                                    }}
                                >
                                    <UiIcon
                                        size={20}
                                        icon={ICONS["EXIT_ICON"]}
                                    />
                                    Выйти из профиля
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
});
